import Swal from "sweetalert2"
import { db } from "../firebase/firebase-config"
import { fileUpload } from "../helpers/fileUpload"
import { loadNotes } from "../helpers/loadNotes"
import { types } from "../types/types"

import { sort } from 'fast-sort';


export const startNewNote = () => {
    return async (dispatch, getState) => {

        const { uid } = getState().auth

        const newNote = {
            title: '',
            body: '',
            date: new Date().getTime(),
            fav: false
        }

        //Hace una inserción en la colección que corresponde con el uid del usuario
        //Que dentro tiene un documento llamado journal que a su vez tiene una colección
        //Que guarda objetos not

        const doc = await db.collection(`${uid}/journal/notes`).add(newNote)
        dispatch(activeNote(doc.id, newNote))
        dispatch(addNewNote(doc.id, newNote))
    }
}

export const activeNote = (id, note) => ({
    type: types.notesActive,
    payload: {
        id,
        ...note
    }
})

export const addNewNote = (id, note) => ({
    type: types.notesAddNew,
    payload: {
        id, ...note
    }
})

export const startLoadingNotes = (uid) => {
    return async (dispatch) => {
        const notes = await loadNotes(uid);
        dispatch(setNotes(notes))
    }
}
export const setNotes = (notes) => ({
    type: types.notesLoad,
    payload: notes
})

const getNoteToFirestore = (note) => {
    console.log(note)
    const noteToFirestore = { ...note };

    if (!note.url) {
        delete noteToFirestore.url;
    }

    delete noteToFirestore.id;
    return noteToFirestore
}

export const startSaveNote = (note) => {
    return async (dispatch, getState) => {
        const { uid } = getState().auth
        const noteToFirestore = getNoteToFirestore(note);

        await db.doc(`${uid}/journal/notes/${note.id}`).update(noteToFirestore);

        dispatch(refreshNote(note.id, note))
        
        Swal.fire('Saved', note.title, 'success')
    }
}

export const refreshNote = (id, note) => ({
    type: types.notesUpdated,
    payload: { id, note }
})

export const startUploading = (file) => {
    return async (dispatch, getState) => {
        const { active: note } = getState().notes;
        Swal.fire({
            title: 'Uploading...',
            text: 'Please wait...',
            showConfirmButton: false,
            allowOutsideClick: false,
            willOpen: () => {
                Swal.showLoading();
            }

        })
        const fileUrl = await fileUpload(file);
        note.url = fileUrl;
        dispatch(startSaveNote(note))
        Swal.close()
    }
}

export const startDeleting = (id) => {
    return async (dispatch, getState) => {
        const uid = getState().auth.uid;
        await db.doc(`${uid}/journal/notes/${id}`).delete();
        //Vale lo borré de la base de datos, ahora lo tengo que borrar de redux
        dispatch(deleteNote(id));
    }
}

export const deleteNote = (id) => ({
    type: types.notesDelete,
    payload: id
});

export const noteLogout = () => ({
    type: types.notesLogoutCleaning
})

export const toggleFav = (note) => {
    return async (dispatch, getState) => {
        const { uid } = getState().auth

        let noteToFirestore = getNoteToFirestore(note);
        noteToFirestore.fav = !note.fav
        await db.doc(`${uid}/journal/notes/${note.id}`).update(noteToFirestore);
        noteToFirestore.id = note.id;

        dispatch(refreshNote(note.id, noteToFirestore))
        const { notes } = getState().notes;
        const sorted = sort(notes).by([
            { desc: note => note.fav },
            { desc: note => note.date }
        ]);

        dispatch(setNotes(sorted))
    }
}